export const TID = {
  nav: {
    logo: "nav-logo",
    linkServices: "nav-link-services",
    linkPricing: "nav-link-pricing",
    linkProcess: "nav-link-process",
    linkContact: "nav-link-contact",
    ctaOrder: "nav-cta-order",
  },
  hero: {
    section: "hero-section",
    ctaOrder: "hero-cta-order",
    ctaWhatsapp: "hero-cta-whatsapp",
    scrollHint: "hero-scroll-hint",
  },
  services: {
    section: "services-section",
    card: (id) => `service-card-${id}`,
    orderBtn: (id) => `service-order-${id}`,
  },
  pricing: {
    section: "pricing-section",
    card: (id) => `pricing-card-${id}`,
    orderBtn: (id) => `pricing-order-${id}`,
  },
  payments: {
    section: "payments-section",
    badge: (name) => `payment-badge-${name.toLowerCase().replace(/\s+/g, "-")}`,
  },
  process: {
    section: "process-section",
  },
  testimonials: {
    section: "testimonials-section",
  },
  contact: {
    section: "contact-section",
    form: "contact-form",
    inputName: "contact-input-name",
    inputPhone: "contact-input-phone",
    selectService: "contact-select-service",
    inputMessage: "contact-input-message",
    submitBtn: "contact-submit-btn",
    successMsg: "contact-success-msg",
    errorMsg: "contact-error-msg",
  },
  footer: {
    section: "footer-section",
    whatsapp: "footer-whatsapp",
    call: "footer-call",
  },
  floating: {
    whatsapp: "floating-whatsapp-btn",
  },
};
